/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { Icon } from 'learning-panel-components';
import { coreService } from 'network-utils';
import { FC } from 'react';
import { translate } from 'translations';
import styles from './learningPathContent.module.scss';
import LearningPathItemContent from './learningPathItemContent';

const LearningPathContent: FC<LearningPathContentProps> = (props: LearningPathContentProps) => {
    const { typeAndNumber, onSelect, isOpen, selectedItem } = props;

    return (
        <>
            <div className={styles.container}>
                <Icon name="pathThin" />
                <div className={styles.text}>
                    {translate('NodesInThisPath_x', { minutes: String(Object.values(typeAndNumber).length) })}
                </div>
            </div>
            <div className={isOpen ? styles['content-wrapper-small'] : styles['content-wrapper']}>
                {Object.entries(typeAndNumber).map(([type, value]) => {
                    return (
                        <LearningPathItemContent
                            type={type as Partial<coreService.LearningPathContentType>}
                            numberOfItems={value}
                            isSelected={selectedItem === type}
                            onSelect={onSelect}
                            key={type}
                            isOpen={isOpen}
                        />
                    );
                })}
            </div>
        </>
    );
};

export interface LearningPathContentProps {
    typeAndNumber: Partial<{ [key in coreService.LearningPathContentType]: number }>;
    onSelect: Function;
    selectedItem: coreService.LearningPathContentType | null;
    isOpen: boolean;
}

export default LearningPathContent;
